<template>
  <div>
    <div id="modalWritePackageinfo" class="modal fade" data-backdrop="static">
      <div
        class="modal-dialog modal-dialog-vertical-center modal-lg"
        :class="{ 'modal-max': max }"
        role="document"
      >
        <div class="modal-content bd-0 tx-14 overflow-y-auto">
          <div class="modal-header pd-y-20 pd-x-25">
            <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
              {{ $t("order.订单") }}[{{ item.code }}]{{ $t("order.发货")
              }}<span class="tx-danger tx-normal mg-l-10">{{
                $t("order.(可拆分成多个包裹发货，请每次发货后及时录入包裹信息)")
              }}</span>
            </h6>
            <div>
              <button type="button" class="size" @click="changeSize">
                <i
                  class="fa"
                  :class="max ? 'fa-window-restore' : 'fa-window-maximize'"
                ></i>
              </button>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
          </div>
          <div
            class="modal-body pd-x-25"
            :style="{ maxHeight: max ? maxH + 'px' : '460px' }"
          >
            <form id="deliveryOrderFrom">
              <div class="form-group row mg-b-5">
                <label
                  class="col-md-2 col-form-label form-control-sm text-right"
                >
                  {{ $t("order.发货方式：") }}
                </label>
                <div class="col-md-4 col-sm-12 d-flex align-items-center row">
                  <select
                    class="form-control form-control-sm"
                    style="max-width: 70%"
                    v-model="deliveryType"
                  >
                    <option value="1">{{ $t("order.物流发货") }}</option>
                    <option value="2">{{ $t("order.买家上门自取") }}</option>
                    <option value="3">{{ $t("order.送货上门") }}</option>
                  </select>
                </div>
                <template v-if="deliveryType == 1 || deliveryType == 3">
                  <label
                    class="col-md-2 col-form-label form-control-sm text-right"
                  >
                    {{ $t("order.包裹运费：") }}
                  </label>
                  <div class="col-md-4 col-sm-12 row">
                    <input
                      v-PRICE
                      class="form-control form-control-sm"
                      style="max-width: 70%"
                      :placeholder="$t('order.如已包邮，运费填0')"
                      v-model="parcelFreight"
                      type="text"
                      name="trackFee"
                      id="trackFee"
                    />
                  </div>
                </template>
              </div>
              <div class="form-group row mg-b-5" v-show="deliveryType == 1">
                <label
                  class="
                    col-md-2 col-sm-12 col-form-label
                    form-control-sm
                    text-right
                  "
                  >{{ $t("order.物流公司：") }}</label
                >
                <div class="col-md-4 col-sm-12 row align-items-center">
                  <input
                    style="max-width: 70%"
                    v-model.trim="logisticsCompany"
                    type="text"
                    class="form-control form-control-sm"
                    :placeholder="$t('outside.请输入物流公司名称')"
                  />
                </div>
                <label
                  class="
                    col-md-2 col-sm-12 col-form-label
                    form-control-sm
                    text-right
                  "
                  >{{ $t("order.运单号：") }}</label
                >
                <div class="col-md-4 col-sm-12 row">
                  <input
                    style="max-width: 70%"
                    v-model.trim="trackNumber"
                    type="text"
                    name="trackNum"
                    class="form-control form-control-sm"
                    :placeholder="$t('order.请输入一个运单号')"
                  />
                </div>
              </div>
              <div
                class="form-group row mg-b-5 align-items-center"
                v-if="deliveryType == 2 || deliveryType == 3"
              >
                <label
                  class="
                    col-md-2 col-sm-12 col-form-label
                    form-control-sm
                    text-right
                  "
                  ><span v-if="!isAutoTrackCode">{{
                    $t("order.运单号：")
                  }}</span></label
                >
                <div
                  class="col-md-3 col-sm-12 row mg-r-15"
                  v-if="!isAutoTrackCode"
                >
                  <input
                    style="max-width: 70%"
                    v-model.trim="trackNumber"
                    type="text"
                    name="trackNum"
                    class="form-control form-control-sm"
                    :placeholder="$t('order.请输入一个运单号')"
                  />
                </div>
                <label
                  class="ckbox d-inline-block mg-b-0 col-md-3 col-sm-12 pd-0"
                >
                  <input type="checkbox" v-model="isAutoTrackCode" />
                  <span>{{ $t("order.自动生成包裹运单号") }}</span>
                </label>
              </div>
              <div class="form-group row d-flex align-items-flex-start">
                <label
                  class="
                    col-md-2 col-sm-12 col-form-label
                    form-control-sm
                    text-right
                    pd-y-0
                  "
                  >{{ $t("order.包含商品：") }}</label
                >
                <div class="col-md-9 col-sm-12 pd-x-0">
                  <table class="w-100 table-striped">
                    <thead>
                      <tr>
                        <td>
                          <label class="ckbox d-inline-block">
                            <input
                              type="checkbox"
                              :checked="isAll"
                              @change="changeAllCheck($event)"
                            />
                            <span></span>
                          </label>
                        </td>
                        <td>{{ $t("order.商品图片") }}</td>
                        <td>SKU</td>
                        <td>
                          {{ $t("order.商品名称") }}
                        </td>
                        <td>{{ $t("order.本次发货数 / 可发数量") }}</td>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-for="(itemjson, indexjson) in product_info">
                        <tr
                          v-if="
                            itemjson.quantity > 0 &&
                            itemjson.deliveryCnt < itemjson.quantity
                          "
                          :key="itemjson.id + indexjson"
                          :id="'alertWarp' + indexjson"
                        >
                          <td>
                            <label class="ckbox d-inline-block">
                              <input
                                type="checkbox"
                                v-model="(productInfo[indexjson] || {}).checked"
                              />
                              <span></span>
                            </label>
                          </td>
                          <td>
                            <a
                              class="img-wrap d-block"
                              href="javascript:;"
                              v-lazy:background-image="itemjson.skuImage"
                              @click="
                                preview(itemjson.skuImage, itemjson.skuName)
                              "
                            >
                            </a>
                          </td>
                          <td>
                            <span class="mg-r-5">{{ itemjson.sku }}</span>
                          </td>
                          <td>
                            <span>
                              {{ itemjson.skuName }}
                            </span>
                          </td>
                          <td>
                            <div
                              class="
                                align-self-center
                                mg-t-20 mg-sm-t-0 mg-l-25
                              "
                            >
                              <input
                                @keyup="changeDeliveryCnt(indexjson)"
                                v-model="
                                  (productInfo[indexjson] || {}).deliveryCnt
                                "
                                type="text"
                                name="itemNum"
                                class="
                                  form-control form-control-sm
                                  wd-60
                                  d-inline-block
                                "
                              />
                              <span>
                                /
                                {{
                                  itemjson.quantity - itemjson.deliveryCnt
                                }}</span
                              >
                            </div>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </div>
            </form>
          </div>
          <div
            class="modal-footer"
            :class="weightTotal > 0 ? 'justify-content-between' : ''"
          >
            <div v-if="weightTotal > 0" class="tx-warning">
              {{ $t("order.当前所选商品的预估重量为：")
              }}<span class="tx-bold">{{ weightTotal }}g</span>
            </div>
            <div class="d-flex align-items-center">
              <div class="tx-gray-900 mg-r-20">
                {{ $t("order.本次发货数量：")
                }}<span class="tx-bold">{{ quantityCheckedTotal }}</span>
                {{ $t("order.可发数量：") }}
                <span class="tx-bold">{{ quantityTotal }}</span>
                {{ $t("order.发货金额") }}({{
                  ($CE[item.currency] || {}).symbol
                }})：<span class="tx-bold tx-danger">{{
                  priceTotal.toFixed(2)
                }}</span>
              </div>
              <button
                type="button"
                class="
                  btn btn-primary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                  mg-r-15
                "
                @click="deliverGoods"
              >
                {{ $t("order.发货") }}
              </button>
              <button
                type="button"
                class="
                  btn btn-secondary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                data-dismiss="modal"
              >
                {{ $t("order.取消") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
    product_info: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      max: true,
      maxH: 460,
      // 发货方式
      deliveryType: 1,
      // 包裹运费
      parcelFreight: "",
      // 物流公司
      logisticsCompany: "",
      // 运单号
      trackNumber: "",
      // 是否自动生成运单号
      isAutoTrackCode: true,
      // 选中的商品id
      productInfo: [],
    };
  },
  computed: {
    isAll() {
      let num = 0;
      this.productInfo.forEach((e) => {
        if (e.checked) {
          num++;
        }
      });
      return num == this.productInfo.length && this.productInfo.length > 0
        ? true
        : false;
    },
    // 重量
    weightTotal() {
      let weight = 0;
      for (let index = 0; index < this.productInfo.length; index++) {
        const element = this.productInfo[index] || {};
        if (element.status && element.checked) {
          const elem = this.product_info[index] || {};
          weight += Number(element.deliveryCnt || 0) * (elem.weight || 0);
        }
      }
      return weight;
    },
    // 本次发货数量
    quantityCheckedTotal() {
      let quantity = 0;
      for (let index = 0; index < this.productInfo.length; index++) {
        const element = this.productInfo[index] || {};
        if (element.status && element.checked) {
          quantity += Number(element.deliveryCnt);
        }
      }
      return quantity;
    },
    // 可发数量
    quantityTotal() {
      let quantity = 0;
      for (let index = 0; index < this.product_info.length; index++) {
        const element = this.product_info[index] || {};
        quantity += Number(element.quantity) - Number(element.deliveryCnt);
      }
      return quantity;
    },
    // 发货金额
    priceTotal() {
      let price = 0;
      for (let index = 0; index < this.productInfo.length; index++) {
        const element = this.productInfo[index] || {};
        if (element.status && element.checked) {
          const elem = this.product_info[index] || {};
          price += Number(element.deliveryCnt) * (elem.price || 0);
        }
      }
      return price;
    },
  },
  watch: {
    product_info() {
      this.productInfo = [];
      for (let i = 0; i < this.product_info.length; i++) {
        if (
          this.product_info[i].quantity - this.product_info[i].deliveryCnt >
            0 &&
          this.product_info[i].deliveryCnt < this.product_info[i].quantity
        ) {
          this.productInfo.push({
            status: true,
            checked: true,
            supplierProductStockId: this.product_info[i].id,
            deliveryCnt:
              this.product_info[i].quantity - this.product_info[i].deliveryCnt,
          });
        } else {
          this.productInfo.push({
            status: false,
            checked: true,
            supplierProductStockId: this.product_info[i].id,
            deliveryCnt:
              this.product_info[i].quantity - this.product_info[i].deliveryCnt,
          });
        }
      }
    },
    deliveryType() {
      if (this.deliveryType == 2) {
        this.parcelFreight = "";
      }
      this.trackNumber = "";
    },
    isAutoTrackCode() {
      this.trackNumber = "";
    },
  },
  mounted() {
    $("#modalWritePackageinfo").on("hidden.bs.modal", (e) => {
      this.deliveryType = 1;
      this.parcelFreight = "";
      this.logisticsCompany = "";
      this.trackNumber = "";
      this.isAutoTrackCode = true;
    });
    $("#modalWritePackageinfo").on("shown.bs.modal", () => {
      this.sizeHeight();
      $(window).on("resize", () => {
        this.sizeHeight();
      });
    });
    $("#modalWritePackageinfo").on("hide.bs.modal", () => {
      $(window).off("resize");
    });
  },
  updated() {
    $(".overflow-y-auto").perfectScrollbar();
    $("#modalWritePackageinfo").on("shown.bs.modal", function () {
      $("#modalWritePackageinfo .modal-body").scrollTop(0);
    });
  },
  methods: {
    sizeHeight() {
      let wH = $(window).height(),
        hH = $("#modalWritePackageinfo .modal-header").height(),
        fH = $("#modalWritePackageinfo .modal-footer").height();
      this.maxH = wH - hH - fH - 160;
    },
    changeSize() {
      this.max = !this.max;
      $("#modalWritePackageinfo .modal-dialog").removeAttr("style");
    },
    preview(img, text) {
      this.$store.commit("setImgItem", [
        {
          img,
          text,
        },
      ]);
      this.$parent.loading = true;
      setTimeout(() => {
        const viewer = document.querySelector(".app-images-arr").$viewer;
        if (viewer.images.length) viewer.show();
        this.$parent.loading = false;
      }, 500);
    },
    // 全选
    changeAllCheck(e) {
      if (e.target.checked) {
        this.productInfo.forEach((e, i) => {
          this.$set(e, "checked", true);
          this.$set(e, "supplierProductStockId", this.product_info[i].id);
        });
      } else {
        this.productInfo.forEach((e) => {
          this.$set(e, "checked", false);
          this.$set(e, "supplierProductStockId", "");
        });
      }
    },
    // 判断发货数不能大于剩余未到货数
    changeDeliveryCnt(t) {
      if (this.productInfo[t].deliveryCnt != "") {
        if (
          isNaN(this.productInfo[t].deliveryCnt) ||
          this.productInfo[t].deliveryCnt <= 0 ||
          this.productInfo[t].deliveryCnt >
            this.product_info[t].quantity - this.product_info[t].deliveryCnt
        ) {
          this.productInfo[t].deliveryCnt =
            this.product_info[t].quantity - this.product_info[t].deliveryCnt;
        }
      }

      if ($("#alertWarp" + t).find($("#alert" + t)) && $("#alert" + t).length) {
        let elT = $("#alert" + t).offset().top,
          elH = $("#alert" + t).height(),
          bodyT = $("#modalWritePackageinfo .modal-body").offset().top,
          bodyH = $("#modalWritePackageinfo .modal-body").height();
        if (elT + elH > bodyT + bodyH) {
          $("#modalWritePackageinfo .modal-body").scrollTop(
            $("#modalWritePackageinfo .modal-body").scrollTop() + elH + 40
          );
        }
      }
    },
    deliverGoods() {
      if (this.deliveryType == 1) {
        if (!this.logisticsCompany)
          return ShowTip(this.$t("outside.请输入物流公司名称"), "danger");
        if (!this.trackNumber)
          return ShowTip(this.$t("order.请输入一个运单号"), "danger");
      } else if (this.deliveryType == 2 || this.deliveryType == 3) {
        if (!this.isAutoTrackCode && !this.trackNumber)
          return ShowTip(this.$t("order.请输入一个运单号"), "danger");
      }
      if (!this.quantityCheckedTotal)
        return ShowTip(this.$t("order.请选择需要发货的商品"), "danger");
      this.$parent.loading = true;
      let productInfo = [];
      this.productInfo.forEach((elem) => {
        if (elem.checked && elem.status) {
          productInfo.push({
            supplierProductStockId: elem.supplierProductStockId,
            deliveryCnt: elem.deliveryCnt,
          });
        }
      });
      $.api_call(
        "api.SupplierPurchaseOrder.deliver",
        {
          code: this.item.code,
          deliveryType: this.deliveryType,
          shippingAmount: this.parcelFreight,
          companyName: this.logisticsCompany,
          expressCode: this.trackNumber,
          productInfo,
        },
        (r) => {
          this.$parent.loading = false;
          if (r.ErrorCode == "9999") {
            ShowTip(this.$t("order.发货成功"), "success");
            $("#modalWritePackageinfo").modal("hide");
            setTimeout(() => {
              this.$parent.getRMOrder(true);
              this.$parent.getRMStatusNum();
            }, 2000);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      );
    },
  },
};
</script>

<style>
.img-wrap {
  min-width: 50px;
  min-height: 50px;
  width: 50px;
  height: 50px;
  background-size: cover;
  background-position: center;
  border: 1px solid #ddd;
  margin-right: 5px;
}
.modal-max {
  min-width: 90% !important;
}
</style>